export default __webpack_public_path__ + "static/lukas-8fd4dc8b1ebae84a9404d3592fc16798.jpg";